"use client";
import React, { useRef } from "react";

interface YoutubeProps {
    link: string;
    src: string;
}

export const YoutubeCard = ({ link, src }: YoutubeProps) => {

    return (
        <div className="bg-[#E3E3E3] p-8">
            <a href={link} target="_blank" className="w-full overflow-hidden" rel="noopener noreferrer">
                <img
                    className="w-full h-auto"
                    src={`/assets/images/youtube/${src}`}
                    width={1200}
                    height={0}
                    alt=""
                />
            </a>
        </div>
    );
};